/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';

import {
    PanelBody
} from '@wordpress/components';

/**
* Internal dependencies
*/
import { VayuBlocksBorder,VayuBlocksBackground } from '@vayu-blocks';

const SwiperStylePanel = ({
            attributes,
            setAttributes,
            openPanels, 
			onTogglePanel ,
        }) => {

    return (
            <>
                    <PanelBody
                     title={ __( 'Slider Navigation', 'vayu-blocks' ) }
                                   opened={openPanels['vb-swiper-nav-style']} onToggle={() => onTogglePanel('vb-swiper-nav-style')}
                                    > 
                         <div className="vayu-blcoks-coloropanel">
                         <VayuBlocksBackground
                              onChange={(key,value)=>setAttributes({[key]:value})}
                             colorPanel = {[
                                    {
                                        active: ['color'],
                                        label: 'Icon Color',
                                        key:'navcolor',
                                        value:attributes.navcolor
                                    
                                    },
                                    {
                                        active: ['gradient'],
                                        label: 'Icon Bg Color',
                                        key:'navbgcolor',
                                        value:attributes.navbgcolor
                                    }
                                ]}
                            />

                            <VayuBlocksBorder 
                                onChange={(key,value)=>setAttributes({[key]:value})}
                                border={{key:'naviconsBorder',value:attributes.naviconsBorder}}
                                borderRadius={{key:'naviconsRadius',value:attributes.naviconsRadius}}
                               
                            />

                        </div>
                    </PanelBody>
                    <PanelBody
                     title={ __( 'Slider Pagination', 'vayu-blocks' ) }
                                    opened={openPanels['vb-swiper-pagi-style']} onToggle={() => onTogglePanel('vb-swiper-pagi-style')}
                                    > 
                         <div className="vayu-blcoks-coloropanel">
                         <VayuBlocksBackground
                              onChange={(key,value)=>setAttributes({[key]:value})}
                             colorPanel = {[
                                    {
                                        active: ['color'],
                                        label: 'Color',
                                        key:'pagicolor',
                                        value:attributes.pagicolor
                                    
                                    },
                                    {
                                        active: ['gradient'],
                                        label: 'Active Color',
                                        key:'pagiActivecolor',
                                        value:attributes.pagiActivecolor
                                    }
                                ]}
                            />
                        </div>
                    </PanelBody>
            </>
    )
}
export default SwiperStylePanel;